import VueLazyloadSsr from '@/assets/js/vue-lazyload.esm'
import loadingImg from '@/assets/images/new_img_loading.png'
import errorImg from '@/assets/images/img_error.jpg'
import customerLazyLoading from '@/assets/images/new_img_loading_2.png'
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('customerLazyLoading', customerLazyLoading)
    nuxtApp.vueApp.use(VueLazyloadSsr, {
        loading: loadingImg,
        error: errorImg,
        preLoad: 1, // 提前加载屏幕外多大范围内的图片，1表示只加载显示在屏幕上的图片。默认1.3
        throttleWait: 50, // v-lazy处理方法的节流器时间。默认200
    })
})